<template>
  <div v-if="!isShop" class="logo" @click="backToIndex">
    <div class="image"></div>
  </div>
  <div v-else class="logo" @click="backToShop">
    <div class="image image-shop"></div>
  </div>
</template>

<script>
import EnvConfig from "@/const/configs/env.config.js";

export default {
  name: "ros-admin-header",
  data() {
    return {
      isRegister: this.$route.path.toLocaleLowerCase() === "/register",
      isShop: this.$route.path.toLocaleLowerCase() === "/shop",
    };
  },
  methods: {
    backToIndex: function () {
      if (this.$route.path !== "/privacy-policy") { // app 隐私协议禁止跳转
        location.href = EnvConfig.WEBSITE_DOMAIN;
      }
    },
    backToShop: function () {
      location.href = 'https://shop.123-ai.cn/';
    },
    register: function () {
      this.$data.isRegister = true;
      this.$router.push("/register");
    },
    login: function () {
      this.$data.isRegister = false;
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  padding: 24px 0 0 40px;
  z-index: 1;
  .image {
    background: url("../assets/logo.png") no-repeat;
    background-size: 194px;
    width: 148px;
    height: 50px;
    cursor: pointer;
  }

  .image-shop {
    background: url("../assets/logo-shop.png") no-repeat;
    background-size: 194px;
    width: 170px;
    height: 50px;
    cursor: pointer;
  }

  .text {
    margin-left: 12px;
    font-size: 24px;
    color: #fff;
    white-space: nowrap;
  }
}

.button-group {
  display: flex;
  flex-wrap: nowrap;

  span {
    color: #fff;
    padding: 10px;
  }

  button {
    padding: 10px 20px;
    font-size: 16px;
    color: #fff;
    border-radius: 38px;
    border-color: #fff;
    background: transparent;
  }
}
</style>
